import { render, staticRenderFns } from "./commentLikeComponent.vue?vue&type=template&id=68f257f7&scoped=true"
import script from "./commentLikeComponent.vue?vue&type=script&lang=js"
export * from "./commentLikeComponent.vue?vue&type=script&lang=js"
import style0 from "./commentLikeComponent.vue?vue&type=style&index=0&id=68f257f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f257f7",
  null
  
)

export default component.exports